import React, { Component } from 'react';
import { Field, withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as Yup from 'yup';

import Input from 'components/Input';
import Button from 'components/Button';
import AuthModule from 'modules/auth';
import ROUTES from 'config/routes';


class RestorePassForm extends Component {
  render() {
    const { handleSubmit, values, handleReset } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="content-block text-center">
            <p>Enter your email we'll send you a link<br />to reset your password.</p>
          </div>
        </div>

        <div className="field-wrap">
          <Field
            name="email"
            type="email"
            placeholder="Email Address"
            component={Input}
            isRequired={true} />
        </div>
        <div className="field-wrap text-center">
          <Button
            bgColor={null}
            width='auto'
            to={ROUTES.signIn}>Remember password?</Button>
        </div>
        <div className="text-center">
          <Button
            bgColor="green"
            type="submit">Send link</Button>
        </div>
      </form>
    )
  }
}

export default compose(
  connect(
    null,
    {
      forgotPassword: AuthModule.forgotPassword,
    }
  ),
  withFormik({
    mapPropsToValues: () => {
      return {
        email: "",
      }
    },
    handleSubmit: (values, { props }) => {
      const sendData = { ...values };
      props.forgotPassword(sendData);
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email('Invalid email')
        .required('Required'),
    }),
  }),
)(RestorePassForm);
